import { request } from './request'

//签到
export function getSign() {
  return request({
    url: '/user/sign',
    method: "get",
  })
}
export function getSignInfo() {
  return request({
    url: '/user/sign_info',
    method: "get",
  })
}
// 轮播图
export function getBanners() {
  return request({
    url: '/banners',
    method: "get",
  })
}
// 签到总揽
export function getOverview() {
  return request({
    url: '/sign-in/overview',
    method: "get",
  })
}